export const TRANSITIONS = {
  SLIDE: {
    LEFT: "LEFT",
    RIGHT: "RIGHT",
    UP: "UP",
    DOWN: "DOWN",
  },
};
